import React, { useState, useEffect } from "react";
import AnnualHeadStats from "../components/annualViewNew/annualHeadStats";
import AnnualViewTabs from "../components/annualView/annualViewTabs";
import { annualViewTabs as AnnualViewTabsStyle } from "../css/styles/componentStyles";
import FinancialDashboard from "../components/annualView/Summary/summary";
import AnnualTotalTable from "../components/annualViewNew/annualTotalTable";
// import DateFilterSelect from "../../../../Common/DateFilterSelectold"
import { useSelector, useDispatch } from 'react-redux';
import DateFilterSelect from "../../../../../../CustomDatePicker/DateFilterSelectold";
import AccruedDropdown from "../components/AccruedDropdown";
// import DateFilterSelect from "../DateFilter";
import moment from "moment";
import Loader from '../../../../../../presentationals/Loader/Loader.component'
// import Loader from "../../../../Common/Loader.component"
import { FILTER_ACTION } from '../../../../../../../reducers/CommonFilters.reducer';
// import { FILTER_ACTION } from "../../../../reducers/CommonFilters.reducer";
import {
  getAnnualTotalReport,
  getRemainingSummary,
  getExpenseOverviewByDateRangeFilters,
  getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters,
  getIncomeGrowhtByDateRangeFilters
} from "../utils/ActionCreator";
import useMockLoading from "../hooks/useMockLoading";
import { AnnualHeaderStatsSkeleton, AnnualTableSkeleton } from "../components/skeletons/DashboardSkeleton";

const AnnualView = () => {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const [dateFilterPopup, setDateFilterPopup] = useState({ from: fromDate, to:toDate })
  const [accured, setAccured] = useState("")
  const [loader, setLoader] = useState(false)
  const [apiData, setApiData] = useState({ api1: {}, api2: {},api3:[] })

  const [activeTab, setActiveTab] = useState("annual");
  const [remainingSummary, setRemainingSummary] = useState({});
  const [annualTotalReport, setAnnualTotalReport] = useState({});

  const mockLoading = useMockLoading([dateFilterPopup.from, dateFilterPopup.to, accured], 600);

  // const fetchData = () => {
  //   const currentYear = new Date().getFullYear();
  //   const startDate = `${currentYear}-01-01`;
  //   const endDate = `${currentYear}-12-31`;

  //   getRemainingSummary(
  //     startDate,
  //     endDate,
  //     (callback) => {
  //       setRemainingSummary(callback);
        
  //     },
  //     (onErr) => {
  //       setRemainingSummary({});
        
  //     },
  //   );
  // };


  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev;

      return {
        ...prev,
        [type]: formatted
      };
    });
    if (type === "from") {
      if (dateFilterPopup.from !== formatted) {
        // dispatch({ type: FILTER_ACTION, payload: { "fromDate": formatted } });
      }
    } else {
      if (dateFilterPopup.to !== formatted) {
        // dispatch({ type: FILTER_ACTION, payload: { "toDate": formatted } });
      }
    }
  }

  useEffect(() => {
    const obj = { from: dateFilterPopup.from, to: dateFilterPopup.to, accured: accured }
    MainApi(obj);
  }, [dateFilterPopup.from, dateFilterPopup.to, accured]);


  const MainApi = (data) => {
    
    getExpenseOverviewByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api1: callback ?? {}
      }))
    }, (error) => {
      console.error("getExpenseOverviewByDateRangeFilters error:", error);
    })
    setLoader(true)
    getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
       setLoader(false)
      setApiData((prev) => ({
        ...prev,
        api2: callback ?? {}
      }))
    }, (error) => {
      console.error("getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters error:", error);
    })
    getIncomeGrowhtByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api3: callback ?? []
      }))
    }, (error) => {
      console.error("getIncomeGrowhtByDateRangeFilters error:", error);
    })

   
  }



  return (
    <>
    {loader ? <Loader />:""}
      <div style={AnnualViewTabsStyle.container}>
        <div style={AnnualViewTabsStyle.tabContainer}>
         
          {/* <AnnualViewTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
          <div
            // style={AnnualViewTabsStyle.contentContainer}
            className="hide-scrollbar"
          >
            <div
              style={{
                ...AnnualViewTabsStyle.content,
                width:'100%'
                // transform: `translateX(${activeTab === "annual" ? "0%" : "-50%"})`,
              }}
            >
              <div style={{...AnnualViewTabsStyle.panel,width:'100%'}}>
                  <div style={{ background: "#fff",
                    padding: '16px 24px', borderRadius: '12px', margin: "0 0 24px 0", 
                    boxShadow: "none",
                    border: "1px solid rgba(226, 232, 240, 0.8)",
                    width:'stretch'
                    }}>
                    <div className="row">
                      <div className=" col-xs-12" style={{ display: 'flex', flexWrap: 'wrap', gap: "15px 24px", alignItems: 'center' }}>
                        <DateFilterSelect
                          value={[new Date(dateFilterPopup.from), new Date(dateFilterPopup.to)]}
                          onChange={(range) => {
                            handleDateFilterPopup("from", range[0]);
                            handleDateFilterPopup("to", range[1]);
                          }}
                          isFilterCleared={false}
                          customStyle={{
                            border: "1px solid #d1d5db",
                            padding: "8px 14px",
                            height: "38px",
                            alignItems: "center",
                            boxSizing: "border-box",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            color: "#374151"
                          }}
                        />
                        <AccruedDropdown value={accured} onChange={setAccured} />
                      </div>
                    </div>
                  </div>
                {mockLoading ? (
                  <>
                    <AnnualHeaderStatsSkeleton />
                    <div style={{ height: "20px" }} />
                    <AnnualTableSkeleton />
                  </>
                ) : (
                  <>
                    <AnnualHeadStats remainingSummary={remainingSummary} apiData={apiData}/>
                    <AnnualTotalTable apiData={apiData}/>
                  </>
                )}
              </div>
              {/* <div style={AnnualViewTabsStyle.panel}> */}
                {/* <AnnualHeadStats /> */}
                {/* <FinancialDashboard /> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnualView;
